import React, { useMemo } from 'react';
import { pluginLink } from 'wix-rich-content-plugin-link/viewer';
import { pluginLineSpacing } from 'wix-rich-content-plugin-line-spacing/viewer';
import styles from './ricos-viewer.scss';
import { WixRicosViewer } from '@wix/ricos-viewer';
import classNames from 'classnames';
import { useStyleParams } from '../../contexts/style-params-context';
import { getStyleParamsTheme } from './theme-utils';
import { useConfig } from '../../contexts/config-context';
const RicosViewer = _ref => {
  let {
    content,
    className,
    customTheme
  } = _ref;
  const styleParams = useStyleParams();
  const {
    locale
  } = useConfig();
  const ricosTheme = useMemo(() => getStyleParamsTheme({
    styleParams,
    customTheme
  }), [customTheme, styleParams]);
  if (!content) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement(WixRicosViewer, {
    biSettings: {
      consumer: 'Forms',
      platform: 'Livesite',
      postId: '',
      containerId: ''
    },
    instance: "",
    theme: ricosTheme,
    content: content,
    plugins: [pluginLink(), pluginLineSpacing()],
    locale: locale
  }));
};
export default RicosViewer;
//# sourceMappingURL=ricos-viewer.js.map